import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  Inject,
  ElementRef,
  ViewChild,
  AfterViewInit,
} from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { DialogConfirmData } from './dialog-confirm-data';

@Component({
  selector: 'app-dialog-confirm',
  standalone: false,
  templateUrl: './dialog-confirm.component.html',
  styleUrls: ['./dialog-confirm.component.css'],
})
export class DialogConfirmComponent implements OnInit, AfterViewInit {
  @ViewChild('btnNo', { read: ElementRef }) btnNo: ElementRef;
  @Input('title') title: string;
  @Input('text') text: string;
  @Output('onOk') onClick: EventEmitter<any> = new EventEmitter<any>();

  constructor(@Inject(MAT_DIALOG_DATA) public data: DialogConfirmData) {}

  ngOnInit(): void {}

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.btnNo.nativeElement.querySelector('button').focus();
    }, 200);
  }

  ok() {
    this.onClick.emit();
  }
}
